// Colour-coded lead-time indicator for a line item.
// Green ≤3d · Amber 4-14d · Red 15d+ · Grey unknown.
// For _custom rows the days become inline-editable.
// Extracted from QuoteBuilder.jsx (Wave K refactor).

export default function AvailabilityChip({ days, onChange, testid = "avail-days-input" }) {
  const n = (days == null || days === "") ? null : Number(days);
  const isUnknown = n == null || Number.isNaN(n);
  let tone = "slate";
  let label = "—";
  if (!isUnknown) {
    if (n <= 3) tone = "green";
    else if (n <= 14) tone = "warn";
    else tone = "red";
    label = `${n}d`;
  }
  const toneMap = {
    green: { bg: "rgba(6, 214, 160, 0.18)", border: "rgba(6, 214, 160, 0.45)", color: "#7EEBC6" },
    warn:  { bg: "rgba(247, 194, 112, 0.18)", border: "rgba(247, 194, 112, 0.45)", color: "#F7C270" },
    red:   { bg: "rgba(239, 71, 111, 0.18)", border: "rgba(239, 71, 111, 0.45)", color: "#FF87A5" },
    slate: { bg: "rgba(148, 163, 184, 0.12)", border: "rgba(148, 163, 184, 0.30)", color: "#94A3B8" },
  };
  const t = toneMap[tone];
  if (onChange) {
    return (
      <div style={{ position: "relative", width: "100%", maxWidth: 60, margin: "0 auto" }} title="Lead time in days">
        <input
          type="number" min="0" step="1"
          value={isUnknown ? "" : n}
          onChange={(e) => onChange(e.target.value === "" ? null : Math.max(0, Math.round(Number(e.target.value))))}
          className="t2-input t2-mono t2-step-input"
          data-testid={testid}
          style={{
            width: "100%", textAlign: "center", padding: "6px 14px 6px 4px",
            borderLeft: `3px solid ${isUnknown ? "var(--t2-border)" : t.border}`,
            fontWeight: 800, fontSize: 14,
          }}
          placeholder="–"
        />
        <span className="t2-mono" style={{ position: "absolute", right: 6, top: "50%", transform: "translateY(-50%)", fontSize: 10, fontWeight: 700, color: "var(--t2-grey3)", pointerEvents: "none" }}>d</span>
      </div>
    );
  }
  return (
    <span
      title={isUnknown ? "Lead time unknown — set once live product data is mapped" : `${n} day lead time`}
      style={{
        display: "inline-flex", alignItems: "center", justifyContent: "center",
        minWidth: 40, padding: "3px 8px", borderRadius: 6,
        background: t.bg, border: `1px solid ${t.border}`, color: t.color,
        fontFamily: "var(--t2-mono)", fontSize: 11.5, fontWeight: 800,
      }}
    >{label}</span>
  );
}
